import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Tooltip, Button, Select, MenuItem, Typography, TextField, Box } from '@mui/material';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import TableContainer from '@mui/material/TableContainer';
import Paper from '@mui/material/Paper';
import Modal from 'react-bootstrap/Modal';
import axios, { renderDoc, decryptData } from '../Axiosinstance';
import './Manage.css';
import { FaRegUser, FaIdCard, FaHome, FaLink, FaGenderless, FaRegBuilding, FaBookOpen, FaInfoCircle, FaPhoneAlt, FaCalendarAlt, FaGlobe, FaPassport, FaEnvelope, FaBuilding, FaMapMarkerAlt, FaUserFriends } from 'react-icons/fa';
import { Row, Col } from 'react-bootstrap';
import { Grid } from '@mui/material';
import { faMapMarkerAlt, faPhone } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { removeBracketedText } from '../Axiosinstance';
import * as XLSX from "xlsx";
import { buttonBackgroundColor } from '../common';


const Green = () => {
  const { batchId, intakeId } = useParams();
  const batchId1 = decryptData(decodeURIComponent(batchId))
  const intakeId1 = decryptData(decodeURIComponent(intakeId))
  const [showModal, setShowModal] = useState(false);

  const [selectedStudentData, setSelectedStudentData] = useState(null);
  const [students, setStudents] = useState([]);
  const [externalStudents, setExternalStudents] = useState([]);

  const [filterName, setFilterName] = useState('');
  // Update filter state for name


  const handleFilterChange = (event) => {
    setFilterName(event.target.value);
  };

  const filteredStudents = Array.isArray(externalStudents)
    ? externalStudents.filter((student) =>
      student.name.toLowerCase().includes(filterName.toLowerCase()) ||
      student.nric.toLowerCase().includes(filterName.toLowerCase())
    )
    : [];

  const sortedFilteredStudents = filteredStudents.sort((a, b) => {
    // Extract sessionDate from the first courseFeeDetails or use a fallback if missing
    const sessionDateA = a.courseFeeDetails && a.courseFeeDetails.length > 0
      ? new Date(a.courseFeeDetails[0].sessionDate)
      : null;  // Return null if no sessionDate exists

    const sessionDateB = b.courseFeeDetails && b.courseFeeDetails.length > 0
      ? new Date(b.courseFeeDetails[0].sessionDate)
      : null;  // Same fallback here

    // If sessionDate is missing, treat them as less recent (move them to the end)
    if (sessionDateA === null) return 1;  // Move `a` to the end if no sessionDate
    if (sessionDateB === null) return -1; // Move `b` to the end if no sessionDate

    // Sort by sessionDate in descending order (latest to earliest)
    return sessionDateB - sessionDateA;
  });


  console.log("Batch ID:", batchId);
  console.log("Intake ID:", intakeId);

  useEffect(() => {
    fetchDataFromAPI();
    fetchExternalDataFromAPI11();
  }, [intakeId1]);


  const fetchDataFromAPI = async () => {
    try {
      const response = await axios.get('manages');
      const allStudents = response.data;
      const filteredStudents = allStudents.filter(student => student.batch_id === parseInt(batchId1));
      setStudents(filteredStudents);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  const fetchExternalDataFromAPI11 = async () => {
    try {
      // const response1 = await axios.get(`registrationadvances/registration/active`);
      const response1 = await axios.get(`/registrationadvances/registration/active?intakeId=${intakeId1}`);
      const externalData = response1.data;

      setExternalStudents(externalData);

      externalData.forEach(item => {
        if (item.scheduleDate) {
          const startDateForModulus0 = item.scheduleDate.find(schedule => schedule.startModulus === 0)?.startDate;
          const endDateForModulus5 = item.scheduleDate.find(schedule => schedule.startModulus === 5)?.endDate;

          if (startDateForModulus0) {
            console.log('Start Date for Modulus 0:', startDateForModulus0);
          }
          if (endDateForModulus5) {
            console.log('End Date for Modulus 5:', endDateForModulus5);
          }
        }
      });


    } catch (error) {
      console.error('Error fetching external data:', error);
    }
  };


  const handleView = async (studentId, value) => {
    try {
      const url = value
        ? `/registrationadvances/getAllAlumni/${studentId}`
        : `/registrationadvances/${studentId}`;

      const response = await axios.get(url);
      console.log("response:", response);

      setSelectedStudentData(response.data);
      setShowModal(true);
    } catch (error) {
      console.error('Error fetching student data:', error);
    }
  };


  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedStudentData(null);
  };


  // const [page, setPage] = useState(0);
  // const [rowsPerPage, setRowsPerPage] = useState(5);

  // // Handle page change
  // const handleChangePage = (event, newPage) => {
  //   setPage(newPage);
  // };

  // // Handle rows per page change
  // const handleChangeRowsPerPage = (event) => {
  //   setRowsPerPage(parseInt(event.target.value, 10));
  //   setPage(0);
  // };

  // Paginate data
  // const paginatedStudents = externalStudents.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

  const exportToExcel = (data, fileName) => {
    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
    XLSX.writeFile(workbook, `${fileName}.xlsx`);
  };


  const maskNRIC_FIN = (value) => {
    if (!value) return "";
    let masked = value.slice(0, -4).replace(/\w/g, "*"); // Mask all but the last 4 characters
    return masked + value.slice(-4); // Append the last 4 characters
  };

  return (
    <div className='container-responsive' style={{ width: '100%', padding: '0 16px' }}>
      <Grid container spacing={2} alignItems="center" sx={{ mb: 2, mt: 2 }}>
        {/* Filter Input */}
        <Grid item xs={12} sm={7} md={8} lg={9}>
          <TextField
            label="Filter by Name"
            variant="outlined"
            size="small"
            fullWidth
            value={filterName}
            onChange={handleFilterChange}
            sx={{
              '& .MuiOutlinedInput-root': {
                borderRadius: '4px',
              }
            }}
          />
        </Grid>
        {/* Download Button */}
        <Grid item xs={12} sm={5} md={4} lg={3}>
          <Box sx={{ display: 'flex', height: '100%' }}>
            <Button
              variant="contained"
              color="primary"
              size="small"
              fullWidth
              onClick={() =>
                exportToExcel(
                  externalStudents.map((student, index) => ({
                    "S.NO": index + 1,
                    "Student Name": student.name.toUpperCase(),
                    Email: student.email,
                    "Intake Id": student.intakeId,
                    "Phone Number": student.handPhone,
                    "NRIC/FIN": student.nric,
                    "Enroll Date": new Date(student.enrolledDate).toLocaleDateString("en-GB"),
                  })),
                  "Students_Data"
                )
              }
              sx={{
                py: 1,
                px: 3,
                fontSize: '0.875rem',
                fontWeight: 500,
                textTransform: 'none',
                boxShadow: 'none',
                height: '100%',
                '&:hover': {
                  boxShadow: '0 2px 4px rgba(0,0,0,0.2)'
                }
              }}
              style={{backgroundColor:buttonBackgroundColor}}
            >
              Download Excel
            </Button>
          </Box>
        </Grid>
      </Grid>
      <TableContainer component={Paper} style={{
        boxShadow: '0 3px 10px rgba(0,0,0,0.2)',
        borderRadius: '8px',
        maxHeight: '500px',  // Set a max height for the container
        overflowY: 'auto'   // Enable vertical scrolling for the table body
      }}>


        <Table sx={{ width: '100%' }}>
          <TableHead>
            <TableRow style={{
              backgroundColor: '#f5f5f5',
              position: 'sticky',
              top: 0,
              zIndex: 1 // Ensure it stays above the table body when scrolling
            }}>
              <TableCell align="center" style={{ fontWeight: "bold" }}>S.No</TableCell>
              <TableCell align="center" style={{ fontWeight: "bold" }}>Student Name</TableCell>
              {/* <TableCell>Email</TableCell> */}
              <TableCell align="center" style={{ fontWeight: "bold" }}>Intake Id</TableCell>
              {/* <TableCell>Phone Number</TableCell> */}
              <TableCell align="center" style={{ fontWeight: "bold" }}>NRIC/FIN</TableCell>
              <TableCell align="center" style={{ fontWeight: "bold" }}>Enroll Date</TableCell>
              <TableCell align="center" style={{ fontWeight: "bold" }}>View</TableCell>

            </TableRow>
          </TableHead>
          <TableBody sx={{
            '& .MuiTableCell-root': {
              textAlign: 'center',
            },
          }}>
            {sortedFilteredStudents.length === 0 ? (
              <TableRow>
                <TableCell colSpan={12} align="center">
                  Loading...
                </TableCell>
              </TableRow>
            ) : (
              sortedFilteredStudents.map((student, index) => (
                <TableRow key={index}>
                  <TableCell>{index + 1}</TableCell>
                  <TableCell>{student.name.toUpperCase()}</TableCell>
                  {/* <TableCell>{student.email}</TableCell> */}
                  <TableCell>{student.intakeId}</TableCell>
                  {/*  <TableCell>{student.handPhone}</TableCell> */}
                  {/* <TableCell>{student.nric}</TableCell> */}
                  <TableCell>{(student.nric)}</TableCell>
                  <TableCell>{new Date(student.enrolledDate).toLocaleDateString("en-GB")}</TableCell>
                  <TableCell>
                    <Button
                      variant="outlined"
                      color="primary"
                      onClick={() =>
                        student.registrationAdvanceId
                          ? handleView(student.registrationAdvanceId, true)
                          : handleView(student.id, false)
                      }
                    >
                      View
                    </Button>
                  </TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
        {/* <TablePagination
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          count={externalStudents.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        /> */}

      </TableContainer>

      {showModal && selectedStudentData && (
        <StudentDetailsModal
          show={showModal}
          onClose={handleCloseModal}
          studentData={selectedStudentData}
        />
      )}

    </div>

  );
};

// StudentDetailsModal Component
const StudentDetailsModal = ({ show, onClose, studentData }) => {
  if (!studentData) return null;

  const moduleDetailsMap = {};
  studentData.batch?.moduleDetails.forEach((module) => {
    moduleDetailsMap[module.id] = module.moduleName;
  });

  const formatDate1 = (dateStr) => {
    const date = new Date(dateStr);
    const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
    return date.toLocaleDateString('en-GB', options);
  };

  const markSheets = studentData?.markSheet;
  const certificate = studentData?.certificate;
  const institutionDetails = studentData?.institutionDetails || [];

  // Filter out any keys that contain "Progress" or "Status" and entries with empty URLs
  const filteredMarkSheets = markSheets
    ? Object.entries(markSheets).filter(([key, url]) =>
      !key.includes('Progress') &&
      !key.includes('Status') &&
      url
    )
    : [];

  const filteredCertificate = certificate
    ? Object.entries(certificate).filter(([key, url]) =>
      !key.includes('Progress') &&
      !key.includes('Status') &&
      url
    )
    : [];


  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };

  return (
    <Modal show={show} fullscreen onHide={onClose} >
      <Modal.Header closeButton>
        <Modal.Title>Student Details</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="student-details">
          <Paper style={{ padding: 20, border: '1px solid #ccc' }}>

            <Grid container spacing={3}>
              {/* Personal Details */}
              <Grid item xs={12} sm={6}>
                <Typography variant="body1"><strong>Name:</strong> {studentData.name || '-'}</Typography>
              </Grid>
              {/* <Grid item xs={12} sm={6}>
    <Typography variant="body1"><strong>Surname:</strong> {studentDetails.student?.name || '-'}</Typography>
  </Grid> */}
              <Grid item xs={12} sm={6}>
                <Typography variant="body1"><strong>Phone No:</strong> {studentData.handPhone || '-'}</Typography>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography variant="body1"><strong>Date of Birth:</strong> {studentData.dob || '-'}</Typography>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography variant="body1"><strong>Gender:</strong> {studentData.gender || '-'}</Typography>
              </Grid>
              {/* <Grid item xs={12} sm={6}>
    <Typography variant="body1"><strong>Nationality:</strong> {studentDetails.nationality || '-'}</Typography>
  </Grid> */}
              <Grid item xs={12} sm={6}>
                <Typography variant="body1"><strong>Passport No:</strong> {studentData.passportNo || '-'}</Typography>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography variant="body1"><strong>Email:</strong> {studentData.email || '-'}</Typography>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography variant="body1"><strong>Type:</strong> {studentData?.type || '-'}</Typography>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography variant="body1"><strong>Course:</strong> {removeBracketedText(studentData?.batch.course) || '-'}</Typography>
              </Grid>
              {/* <Grid item xs={12} sm={6}>
    <Typography variant="body1"><strong>Intake:</strong> {studentDetails?.intake || '-'}</Typography>
  </Grid> */}
              <Grid item xs={12} sm={6}>
                <Typography variant="body1"><strong>Country of Birth:</strong> {studentData?.countryBirth || '-'}</Typography>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography variant="body1"><strong>Know About Program:</strong> {studentData?.knowAboutProgram || '-'}</Typography>
              </Grid>
              {/* <Grid item xs={12} sm={6}>
    <Typography variant="body1"><strong>Application Signature:</strong> {studentDetails?.applicationSignature || '-'}</Typography>
  </Grid> */}
              <Grid item xs={12} sm={6}>
                <Typography variant="body1"><strong>Date:</strong> {formatDate(studentData?.date) || '-'}</Typography>
              </Grid>
              {/* <Grid item xs={12} sm={6}>
    <Typography variant="body1"><strong>Non-Singaporean:</strong> {studentDetails?.nonSingaporean || '-'}</Typography>
  </Grid> */}
              <Grid item xs={12} sm={6}>
                <Typography variant="body1"><strong>Company:</strong> {studentData?.company || '-'}</Typography>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography variant="body1">
                  <strong>
                    {studentData?.proofType === "NRIC" ? "NRIC No:" : studentData?.proofType === "FIN" ? "FIN No:" : "NRIC No:"}
                  </strong>
                  {studentData?.nric || studentData?.fin || '-'}
                </Typography>
              </Grid>

              {/* Address Details */}
              <Grid item xs={12} sm={6}>
                <Typography variant="body1">
                  <FontAwesomeIcon icon={faMapMarkerAlt} /> <strong>Address (Office):</strong> {studentData?.addressOffice || '-'}
                </Typography>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography variant="body1">
                  <FontAwesomeIcon icon={faMapMarkerAlt} /> <strong>Address (Home):</strong> {studentData?.addressHome || '-'}
                </Typography>
              </Grid>

              <Grid item xs={12} sm={6}>
                <Typography variant="body1">
                  <FontAwesomeIcon icon={faPhone} /> <strong>Phone (Office): </strong>{studentData?.phoneOffice || '-'}
                </Typography>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography variant="body1">
                  <FontAwesomeIcon icon={faPhone} /> <strong>Phone (Home): </strong>{studentData?.phoneHome || '-'}
                </Typography>
              </Grid>


              {/* Emergency Contact */}
              <Grid item xs={12} sm={6}>
                <Typography variant="body1">
                  <FontAwesomeIcon icon={faPhone} /> <strong>Emergency Contact:</strong>{studentData.emergencyPhone || 'Not Provided'}
                </Typography>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography variant="body1"><strong>Contact Name:</strong> {studentData?.emergencyName || '-'}</Typography>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography variant="body1"><strong>Relation:</strong> {studentData?.emergencyRelation || '-'}</Typography>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography variant="body1"><strong>Phone:</strong> {studentData?.emergencyPhone || '-'}</Typography>
              </Grid>
            </Grid>
          </Paper>
<br/>
          <h5 style={{ fontWeight: 'bolder' }}>Course Schedule</h5>
          <TableContainer>
            <Table >
              <TableHead>
                <TableRow>
                  <TableCell align="center" style={{ fontWeight: "bold" }}>Start Date</TableCell>
                  <TableCell align="center" style={{ fontWeight: "bold" }}>End Date</TableCell>
                  <TableCell align="center" style={{ fontWeight: "bold" }}>Module</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {studentData?.scheduleDate && studentData.scheduleDate.length > 0 ? (
                  studentData.scheduleDate.map((item, index) => (
                    <TableRow key={index}>
                      <TableCell align="center">{formatDate1(item.startDate)}</TableCell>
                      <TableCell align="center">{formatDate1(item.endDate)}</TableCell>
                      <TableCell align="center">
                        {moduleDetailsMap[item.startModulus] || 'Unknown Module'}
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell align="center" colSpan={3}>
                      <i className="fa fa-exclamation-circle" style={{ marginRight: '5px' }} />
                      No schedule data available
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
            <br/>
            <h5 style={{ fontWeight: 'bolder' }}>Institution Details</h5>
            <Table striped bordered hover responsive>
              <TableHead>
                <TableRow>
                  <TableCell align="center" style={{ fontWeight: "bold" }}>Institution</TableCell>
                  <TableCell align="center" style={{ fontWeight: "bold" }}>Year</TableCell>
                  <TableCell align="center" style={{ fontWeight: "bold" }}>To Year</TableCell>
                  <TableCell align="center" style={{ fontWeight: "bold" }}>Full Time/Part Time</TableCell>
                  <TableCell align="center" style={{ fontWeight: "bold" }}>Qualifications Achieved</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {studentData.institutionDetails && studentData.institutionDetails.length > 0 ? (
                  studentData.institutionDetails.map((institution, index) => (
                    <TableRow key={index}>
                      <TableCell align="center">{institution.institution}</TableCell>
                      <TableCell align="center">{institution.year}</TableCell>
                      <TableCell align="center">{institution?.toYear || '—'}</TableCell>
                      <TableCell align="center">{institution.fullTimeOrPartTime}</TableCell>
                      <TableCell align="center">{institution.qualificationsAchieved}</TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell align="center" colSpan={5}>
                      No data available
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
            <br/>
            <Table style={{ maxWidth: "100%", marginLeft: "4px" }}>
              <TableHead>
                <Typography variant="h6" gutterBottom style={{ fontWeight: 'bolder' }} >Document Details</Typography>
                <TableRow>
                  <TableCell style={{ fontWeight: "bold" }}>Document Name</TableCell>
                  <TableCell style={{ fontWeight: "bold" }}>View</TableCell>
                  {/* <TableCell>Verify</TableCell> */}
                </TableRow>
              </TableHead>
              <TableBody>
                {studentData?.workPermitSpass && (
                  <TableRow key="workPermitSpass">
                    <TableCell>NRIC/WorkPermit/S-Pass</TableCell>
                    <TableCell>
                      <Button variant="contained" style={{backgroundColor:buttonBackgroundColor}}
                         onClick={() => renderDoc(studentData.workPermitSpass)}>View</Button>
                    </TableCell>
                  </TableRow>
                )}

                {studentData?.passport && (
                  <TableRow key="passport">
                    <TableCell >Passport</TableCell>
                    <TableCell >
                      <Button variant="contained" style={{backgroundColor:buttonBackgroundColor}}
                        color="primary" onClick={() => renderDoc(studentData.passport)}>View</Button>
                    </TableCell>
                  </TableRow>
                )}

                {filteredMarkSheets.length > 0 ? (
                  filteredMarkSheets.map(([level, url], index) => (
                    <TableRow key={level}>
                      <TableCell >
                        Marksheet for {institutionDetails[index]?.institution || 'Unknown Institution'}
                      </TableCell>
                      <TableCell >
                        <Button variant="contained" style={{backgroundColor:buttonBackgroundColor}}
                          color="primary" onClick={() => renderDoc(url)}>View</Button>
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  markSheets && (
                    <TableRow>
                      <TableCell colSpan={2} style={{ textAlign: 'center', height: '40px' }}>
                        <i className="fa fa-exclamation-circle" style={{ marginLeft: '5px' }} /> No marksheets available
                      </TableCell>
                    </TableRow>
                  )
                )}

                {filteredCertificate.length > 0 ? (
                  filteredCertificate.map(([level, url], index) => (
                    <TableRow key={level}>
                      <TableCell >
                        Certificate for {institutionDetails[index]?.institution || 'Unknown Institution'}
                      </TableCell>
                      <TableCell >
                        <Button variant="contained" style={{backgroundColor:buttonBackgroundColor}}
                          color="primary" onClick={() => renderDoc(url)}>View</Button>
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  certificate && (
                    <TableRow>
                      <TableCell colSpan={2} style={{ textAlign: 'center', height: '40px' }}>
                        <i className="fa fa-exclamation-circle" style={{ marginLeft: '5px' }} /> No certificate available
                      </TableCell>
                    </TableRow>
                  )
                )}

                {studentData?.profilePicture && (
                  <TableRow key="profilePicture">
                    <TableCell >Profile Picture</TableCell>
                    <TableCell >
                      <Button variant="contained" style={{backgroundColor:buttonBackgroundColor}}
                        color="primary" onClick={() => renderDoc(studentData.profilePicture)}>View</Button>
                    </TableCell>
                  </TableRow>
                )}

                {/* Show this if NO data exists */}
                {!studentData?.workPermitSpass &&
                  !studentData?.passport &&
                  filteredMarkSheets.length === 0 &&
                  filteredCertificate.length === 0 &&
                  !studentData?.profilePicture && (
                    <TableRow>
                      <TableCell colSpan={2} style={{ textAlign: 'center', height: '40px' }}>
                        <i className="fa fa-exclamation-circle" style={{ marginLeft: '5px' }} /> No documents available
                      </TableCell>
                    </TableRow>
                  )}
              </TableBody>

            </Table>
          </TableContainer>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="contained" color='error' onClick={onClose}>Close</Button>
      </Modal.Footer>
    </Modal>

  );

};






export default Green;